import {FACTIONS} from "../../../constants/factions";

export const GREMLINS_QUOTES = [{
  quote: 'Моя железная армия не знает страха. И, что важнее, она не знает усталости',
  author: 'Зип Рэтчет, полевой командир механической когорты гремлинов',
  factionId: FACTIONS.GREMLINS
}, {
  quote: 'Дайте мне кузницу, день и сто пудов железа. Наутро у вас будет сто солдат, которые не спят, не едят и не предают',
  author: 'Шимми Сворк, гремлин-надзиратель сборочными цехов Шумной долины',
  factionId: FACTIONS.GREMLINS
}, {
  quote: 'Автоматон не отступит. Автоматон не спросит "зачем". Автоматон просто сломает то, что ты ему покажешь',
  author: 'Векс Когг, хранитель чертежных Великой Библиотеки гремлинов',
  factionId: FACTIONS.GREMLINS
}, {
  quote: 'Кровь заканчивается. Шестерёнки — никогда',
  author: 'Мекка Брасс, гремлин-разбиратель вражеских осадных орудий',
  factionId: FACTIONS.GREMLINS
}, {
  quote: 'У моего автоматона нет страха. Нет усталости. Нет совести. И нет тормозов',
  author: 'Гризз Феррум, цеховой гремлин-мастер Медных автоматонов',
  factionId: FACTIONS.GREMLINS
}, {
  quote: 'Ошибка в чертеже — это не брак. Это прототип новой модели',
  author: 'Гризз Аксль, безумный гремлин-инноватор',
  factionId: FACTIONS.GREMLINS
}]